<template>
  <b-tabs
      content-class="col-12 col-md-9 mt-1 mt-md-0"
      nav-class="nav-left"
      nav-wrapper-class="col-md-3 col-12"
      pills
      vertical
  >

    <!-- general tab -->
    <b-tab disabled>

      <!-- title -->
      <template #title>
        <feather-icon
            class="mr-50"
            icon="UserIcon"
            size="18"
        />
        <span class="font-weight-bold">General</span>
      </template>
    </b-tab>
    <!--/ general tab -->

    <!-- change password tab -->
    <b-tab active>

      <!-- title -->
      <template #title>
        <feather-icon
            class="mr-50"
            icon="LockIcon"
            size="18"
        />
        <span class="font-weight-bold">Change Password</span>
      </template>

      <account-setting-password/>
    </b-tab>
    <!--/ change password tab -->

    <!-- info -->
    <b-tab disabled>

      <!-- title -->
      <template #title>
        <feather-icon
            class="mr-50"
            icon="InfoIcon"
            size="18"
        />
        <span class="font-weight-bold">Information</span>
      </template>
    </b-tab>

    <!-- social links -->
    <b-tab disabled>

      <!-- title -->
      <template #title>
        <feather-icon
            class="mr-50"
            icon="LinkIcon"
            size="18"
        />
        <span class="font-weight-bold">Social</span>
      </template>
    </b-tab>

    <!-- notification -->
    <b-tab disabled>

      <!-- title -->
      <template #title>
        <feather-icon
            class="mr-50"
            icon="BellIcon"
            size="18"
        />
        <span class="font-weight-bold">Notifications</span>
      </template>
    </b-tab>
  </b-tabs>
</template>

<script>
import {BTab, BTabs} from 'bootstrap-vue'
import AccountSettingPassword from './AccountSettingPassword.vue'

export default {
  components: {
    BTabs,
    BTab,
    AccountSettingPassword,
  },
  data() {
    return {
      options: {},
    }
  },
  beforeCreate() {
    this.$http.get('/account-setting/data').then(res => {
      this.options = res.data
    })
  },
}
</script>
